import styled, { css } from "styled-components";
import { snap, variant } from "@m/alchemy-theme";
export const Toast = styled.div `
  ${(props) => css `
    display: block;

    ${variant("toastType", {
    portal: css `
        position: absolute;
        top: ${props.placement === "bottom" ? "auto" : 0};
        bottom: ${props.placement === "bottom" ? 0 : "auto"};
        left: 0;
        min-height: ${snap(54)};
        height: auto;
        width: 100%;
        right: 0;
      `,
    default: css `
        position: relative;
        min-height: 0;
        height: 0;
      `
})};
  `}
`;
